module.exports = __webpack_public_path__ + "static/media/equestrian.833d9180.svg";